import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AvisoPrivacidad from './utils/aviso_privacidad.js';

import '../assets/css/formulario.css';
import Banner from '../assets/img/BannerSeguimiento.svg';

export class Aviso extends Component {

    render() {
        return (
            <>
                {/*<Banner id="banner-banner" />*/}
                <br />
                <div className="col-sm-1"></div>
                <div className="container-fluid col-sm-10">
                    <Modal id="avisoModalContent" isOpen={true} size="xl" centered>
                        <ModalHeader className="modal-header-style">Aviso de privacidad de datos personales de alumni</ModalHeader>
                        <ModalBody>
                            <AvisoPrivacidad />
                        </ModalBody>
                    </Modal>
                </div>
                <div className="col-sm-1"></div>
            </>
        );
    }
}

export default Aviso;